import Vue from 'vue';
import service from './service';
import { SORT_ORDER } from '@/resources/Constants'
import { CompanyInfoDto } from './dto';
import _ from 'lodash';
import { getGridPagingParams, mapGridPagingState } from '../../shared/utils';

const DEFAULT_SORT_ORDER = SORT_ORDER.ASC;

const state = {
  companies: [],
  company: {},
  selectedId: null,
  companyRoles: [],
  companyAttributes: [],
  companyStatusValues: [],
  parentCompanies: [],
  companyChannels: [],
  submittedByArr: [],
  paging: {
    active: false,
    filters: {
      companyName: null,
      status: null,
      role: null,
      verified: null,
      attribute: null,
    },
    pageNumber: 1,
    pageSize: 50,
    sortBy: 'companyName',
    sortOrder: DEFAULT_SORT_ORDER,
    totalItems: 0,
    totalPages: 0,
  },
  locations: [],
  locationPaging: {
    ...getGridPagingParams(DEFAULT_SORT_ORDER, 'name'),
    filters: {}
  },
  dateRange: null,
  saveResponse: null,
  primaryLocation: 0,
  details: {
    cases: [],
    casesPaging: {
      ...getGridPagingParams(DEFAULT_SORT_ORDER, 'caseName'),
      filters: {}
    },
    network: [],
  },
  corporateTypes: [],
  corporateStates: []
};

const getters = {
  companyById: state => id => state.company[id] || {},
};

const actions = {
  async saveCompanyRecord({ commit, dispatch }, spObj) {
    console.log('start saveCompany');
    const result = await service.saveCompanyRecord(spObj);
    commit('saveResponse', result);
    if (spObj.vwDto.id) {
      dispatch('getById', spObj.vwDto.id);
      return;
    }
    dispatch("getCompanies");

  },
  async getCompanies(
    { commit, state },
    {
      pageNumber = state.paging.pageNumber,
      pageSize = state.paging.pageSize,
      sortBy = state.paging.sortBy,
      sortOrder = state.paging.sortOrder,
      filters = state.paging.filters,
    } = {}
  ) {

    // If value passed in is zero in length but Vuex value is greater
    if (Object.keys(filters).length === 0 && Object.keys(state.paging.filters).length > 0) {
      commit('setFiltersClear');
    }

    //const filtersMerged = { ...state.paging.filters, ...filters };

    const results = await service.getCompanies(
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
      filters
    );

    // Server side value of filter object wrapped around with quotes, so use client-side object and use sortBy instead of sort
    results.paging = { ...results.paging, filters: filters, sortBy: results.paging.sort };
    delete results.paging.sort;

    commit('setCompanies', results);
  },
  // async sortGrid({ commit, state }, sortBy, sortOrder = null) {
  //   if (sortBy == state.sortBy && sortOrder == state.sortOrder) {
  //     return;
  //   }
  //   if (!sortOrder) {
  //     sortOrder =
  //       state.sortOrder == SORT_ORDER.ASC ? SORT_ORDER.DESC : SORT_ORDER.ASC;
  //   }
  //   if (sortBy != state.sortBy) {
  //     sortOrder = DEFAULT_SORT_ORDER;
  //   }
  //   const results = await service.getCompanies(
  //     1,
  //     PAGE_SIZE,
  //     sortBy,
  //     sortOrder,
  //     state.filters
  //   );
  //   commit('setCompanies', { ...results, sortBy, sortOrder });
  // },

  // Lookups
  async getCompanyRoles({ commit }) {
    const results = await service.getCompanyRoles();
    commit('setCompanyRoles', results);
  },
  async getCompanyAttributes({ commit }) {
    const results = await service.getCompanyAttributes();
    commit('setCompanyAttributes', results);
  },
  async getCompanyStatusValues({ commit }) {
    const results = await service.getCompanyStatusValues();
    commit('setCompanyStatusValues', results);
  },
  async getParentCompanies({ commit }) {
    const results = await service.getParentCompanies();
    commit('setParentCompanies', results);
  },
  async getCompanyChannels({ commit }) {
    const results = await service.getCompanyChannels();
    commit('setCompanyChannels', results);
  },
  async getSubmittedBy({ commit }) {
    const results = await service.getSubmittedBy();
    commit('setSubmittedBy', results);
  },
  async getLocations({ commit }, {
    pageNumber = state.locationPaging.pageNumber,
    pageSize = state.locationPaging.pageSize,
    sortBy = state.locationPaging.sortBy,
    sortOrder = state.locationPaging.sortOrder,
    searchValue = state.locationPaging.searchValue,
    companyId
  } = {}, ) {
    const results = await service.getLocations(
      companyId,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
      searchValue
    );
    commit('setLocations', results);
    return results;
  },
  async getById({ commit }, id) {
    return service.getById(id).then(result => {
      commit('getById', result);
      return result;
    });
  },
  async verifyCompany({ commit }, id) {
    return service.verifyCompany(id).then(result => {
      commit('getById', result);

      return (result);
    });
  },
  async selectCompany({ commit }, companyId) {
    commit('setSelectedCompany', companyId);
  },
  async setPrimaryLocation({ state, dispatch }, id) {
    // setting primary location with 2 ids to patch
    await service.setPrimaryLocation([state.primaryLocation, id]);

    // retrieving data using the company Id
    dispatch('getById', state.company.id);
    dispatch('getLocations', { companyId: state.company.id });
  },

  async saveCompanyLocationRecord({ state, commit, dispatch }, spObj) {
    console.log('start saveCompanyLocation', spObj.id);
    const isUpdateRecord = (!_.isUndefined(spObj.id) && spObj.id > 0);
    const result = await service.saveCompanyLocationRecord(spObj, isUpdateRecord);

    if (result.isPrimary && result.id != state.primaryLocation) {
      await service.setPrimaryLocation([state.primaryLocation, result.id]);
    }

    commit('saveResponse', result);
    dispatch('getLocations', { companyId: result.companyId });
  },
  async deleteLocation({ dispatch }, ids) {
    // console.log(state.company.id, 'ID');
    await service.deleteLocation(ids[0]);

    // retrieving data using the company Id
    dispatch('getLocations', { companyId: ids[1] });
  },

  async getCasesDetails({ commit },
    {
      pageNumber = state.details.casesPaging.pageNumber,
      pageSize = state.details.casesPaging.pageSize,
      sortBy = state.details.casesPaging.sortBy,
      sortOrder = state.details.casesPaging.sortOrder,
      filters = state.details.casesPaging.filters,
      companyId
    } = {}, ) {
    const results = await service.getCasesDetails(
      companyId,
      pageNumber,
      pageSize,
      sortBy,
      sortOrder,
      filters
    );
    commit('setCasesDetails', results);
    return results;
  },

  async getNetworksDetails({ commit }, id) {
    const results = await service.getNetworksDetails(id);
    commit('setNetworksDetails', results);
    return results;
  },
  async getCorporateType({ commit }) {
    const results = await service.getCorporateType();
    commit('setCorporateType', results);
  },
  async getCorporateState({ commit }) {
    const results = await service.getCorporateState();
    commit('setCorporateState', results);
  },
  async saveCompanyNotes({ commit, state }) {
    await service.saveCompanyNotes({ companyId: state.company.id, notes: state.company.notes });
  },
  async saveCorporateDetails({ commit, state }) {
    await service.saveCorporateDetails({ businessEntityType: state.company.businessEntityType, companyId: state.company.id, taxEIN: state.company.taxEIN, stateOfIncorporation: state.company.stateOfIncorporation, dunsNumber: state.company.dunsNumber });
  }
};

const mutations = {
  // Company Records
  saveResponse(state, payload) {
    state.saveResponse = payload;
  },
  setCompanies(state, payload) {
    state.companies = [];
    payload.items.forEach(function (item) {
      let i = state.companies.findIndex(x => x.id == item.id);

      if (i <= -1) {
        state.companies.push(item);
      }

      return null;
    });

    ['filters', 'sortBy', 'sortOrder', 'totalItems', 'pageSize', 'pageNumber'].forEach(key => {
      if (payload.paging.hasOwnProperty(key)) {
        if (key === 'filters') {
          state.paging[key] = typeof payload.paging[key] === 'string'
            ? JSON.parse(payload.paging[key])
            : payload.paging[key];
        } else {
          state.paging[key] = payload.paging[key];
        }

      }
    });
    
    //state.paging.filters = payload.filters;
  },
  setFiltersClear(state) {
    //state.dateRange = null;

    Object.keys(state.paging.filters).forEach((filterName) => {
      state.paging.filters[filterName] = null;
    });
  },

  // Lookups
  setCompanyRoles(state, payload) {
    state.companyRoles = payload.items;
  },
  setCompanyAttributes(state, payload) {
    state.companyAttributes = payload;
  },
  setCompanyStatusValues(state, payload) {
    state.companyStatusValues = payload;
  },
  setParentCompanies(state, payload) {
    state.parentCompanies = payload.items;
  },
  setCompanyChannels(state, payload) {
    state.companyChannels = payload.items;
  },
  setSubmittedBy(state, payload) {
    state.submittedByArr = payload.items;
  },
  setLocations(state, payload) {
    const pagingData = payload && payload.paging;

    state.locations = payload && payload.items;

    state.locationPaging = mapGridPagingState(
      state.locationPaging,
      pagingData
    );

    if (!_.isEmpty(state.locations)) {
      const primaryObj = state.locations.filter(location => location.isPrimary);
      // If no primary location, then the first entry will have the auto primary location
      state.primaryLocation = (_.isEmpty(primaryObj)) ? 0 : primaryObj[0].id;
    }

  },
  setSelectedCompany(state, companyId) {
    state.selectedCompany = companyId;
  },
  getById(state, company) {
    state.company = {};
    state.company = company;
  },
  setCasesDetails(state, payload) {
    const pagingData = payload && payload.paging;

    state.details.cases = payload && payload.items;

    state.details.casesPaging = mapGridPagingState(
      state.paging,
      pagingData
    );

  },
  setNetworksDetails(state, payload) {
    state.details.network = [];
    state.details.network = payload.list;
  },
  setCorporateType(state, payload) {
    state.corporateTypes = payload;
  },
  setCorporateState(state, payload) {
    state.corporateStates = payload.items;
  },
};

const companies = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default companies;
